// Read aloud for children who cannot read yet (readAloud.nl.ts). English counterpart.
export const readAloudEn = {
    button: 'Read aloud',
    stop: 'Stop reading',
    task: 'Read {task} aloud',
};
//# sourceMappingURL=readAloud.en.js.map